import { createSlice } from "@reduxjs/toolkit";
import { getAllMinisterialDecisions,addMinisterialDecisions,deleteMinisterialDecisions } from "../services/ministerial_decisions_service";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "ministerial_decisions",
  initialState: {
    isLoading: false,
    ministerial_decisions: [],
  },

  reducers: {},

  extraReducers: {
    // ==> get All Mnisterial Decisions
    [getAllMinisterialDecisions.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.ministerial_decisions = action.payload.data;
    },
    [getAllMinisterialDecisions.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [getAllMinisterialDecisions.pending]: (state) => {
      state.isLoading = true;
    },

     // ==> get All Mnisterial Decisions
     [addMinisterialDecisions.fulfilled]: (state, action) => {
      state.isLoading = false;
   
    },
    [addMinisterialDecisions.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addMinisterialDecisions.pending]: (state) => {
      state.isLoading = true;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const {  } = slice.actions;
